import React from 'react';
import Icon from '../../../components/AppIcon';


const QuickAccessPanel = ({ onQuickAction }) => {
  const quickActions = [
    {
      id: 'password-reset',
      label: 'Reset Password',
      icon: 'KeyRound',
      description: 'Reset your account password',
      color: 'var(--color-warning)'
    },
    {
      id: 'access-request',
      label: 'Request Access',
      icon: 'UserPlus',
      description: 'Request access to new tools',
      color: 'var(--color-primary)'
    },
    {
      id: 'setup-guide',
      label: 'Setup Guides',
      icon: 'BookOpen',
      description: 'View tool setup instructions',
      color: 'var(--color-accent)'
    },
    {
      id: 'it-support',
      label: 'IT Support',
      icon: 'Headphones',
      description: 'Contact IT for assistance',
      color: 'var(--color-success)'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-8">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Zap" size={20} color="var(--color-primary)" strokeWidth={2} />
        <h3 className="font-semibold text-foreground">Quick Actions</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {quickActions?.map((action) => (
          <button
            key={action?.id}
            onClick={() => onQuickAction(action?.id)}
            className="flex flex-col items-start gap-2 p-4 bg-muted/30 hover:bg-muted/50 rounded-lg transition-all duration-200 hover:scale-102 text-left"
          >
            <div className="w-10 h-10 bg-background rounded-lg flex items-center justify-center">
              <Icon name={action?.icon} size={20} color={action?.color} strokeWidth={2} />
            </div>
            <div>
              <p className="font-medium text-foreground text-sm">{action?.label}</p>
              <p className="text-xs text-muted-foreground">{action?.description}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickAccessPanel;